// Lucide icon: receipt-text (https://lucide.dev/icons/receipt-text)
import { ReceiptText } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconBills = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <ReceiptText />
    </IconComponentStyled>
  )
}
